import React, { useState } from "react";
import { useIntl } from "react-intl";
import { SwitchOption } from "@src/lms/jelly/extensions/ui";
import { messages } from "../Interior.messages";
import styles from "./AccordionContent.module.scss";
import { PhotoView } from "../../../../photo-view/PhotoView";
import * as appConfig from "appConfig";

export const AccordionContent1: React.FC = () => {
  const { formatMessage } = useIntl();
  const [selectedOption, setSelectedOption] = useState(0);

  const renderContent = (): JSX.Element => {
    switch (selectedOption) {
      case 0:
        return (
          <PhotoView imgSrc={`${appConfig.STATIC_ASSETS_URL}/lms/case/case08/interior/car1.svg`} imgMode={"contain"} />
        );
      case 1:
        return (
          <PhotoView imgSrc={`${appConfig.STATIC_ASSETS_URL}/lms/case/case08/interior/car2.svg`} imgMode={"contain"} />
        );
      case 2:
        return (
          <PhotoView imgSrc={`${appConfig.STATIC_ASSETS_URL}/lms/case/case08/interior/car3.svg`} imgMode={"contain"} />
        );
      case 3:
        return (
          <PhotoView imgSrc={`${appConfig.STATIC_ASSETS_URL}/lms/case/case08/interior/car4.svg`} imgMode={"contain"} />
        );
      default:
        return <div className={styles.content}>Select an option</div>;
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.contentWrapper}>{renderContent()}</div>
      <div className={styles.switchWrapper}>
        <SwitchOption
          onClick={setSelectedOption}
          activeItem={selectedOption}
          items={[
            {
              name: formatMessage(messages.C8_P3_S1_A1_Content_SwitchButton1_Label),
            },
            {
              name: formatMessage(messages.C8_P3_S1_A1_Content_SwitchButton2_Label),
            },
            {
              name: formatMessage(messages.C8_P3_S1_A1_Content_SwitchButton3_Label),
            },
            {
              name: formatMessage(messages.C8_P3_S1_A1_Content_SwitchButton4_Label),
            },
          ]}
        />
      </div>
    </div>
  );
};
